import { Component, OnInit } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DataTableEvent } from '../../components/data-table/data-table.component';
import { CompositionService } from '@services/compositions/composition.service';
import { DialogService } from '@services/dialog/dialog.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { Models } from '@ibexfusion/models';

export const TypeNameByTypeId = new Map<string, string>([
  ['58a574102870017935415cdb', 'Destination'],
  ['58b3ff7160f6b7576ef14527', 'Accommodation'],
  ['5cf5092f0e53d72284c1db89', 'Screen']
]);

@Component({
    selector: 'app-clean-up-quill',
    templateUrl: './clean-up-quill.component.html',
    styleUrls: ['./clean-up-quill.component.scss'],
    providers: [CompositionService, DynamicContentEntranceService, DynamicContentService],
    standalone: false
})
export class CleanUpQuillComponent implements OnInit {

  public title = 'CleanUp Quill Editor Content';

  public params: any;

  public pageActions: PageAction[];

  public columns = [
    { prop: 'title' },
    {
      prop: 'typeId', name: 'compositionType', valueTransformer: function(id) {
        return TypeNameByTypeId.get(id)
      }
    }
  ];

  public dynamicContent: Models.DynamicContentBase;

  public toDos = 0;
  public message = null;
  public selected = null;
  public dynamicContents = [];
  public readyToExecute = false;
  public running = false;
  public started = null;
  public elapsed = 0;

  constructor(
    public compositionService: CompositionService,
    public dynamicContentEntranceService: DynamicContentEntranceService,
    public dynamicContentService: DynamicContentService,
    private dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.params = { $sort: { _id: -1 } };
  }

  onDetail(event: DataTableEvent) {
    if (this.running) {
      this.dialogService.confirm('already running, please wait!').then(() => {
        return;
      });
      return;
    }
    this.resetData();
    this.selected = event.row.title;
    this.getDynamicContentEntranceIds(event.row.dynamicContentIds).then(children => {
      if (!children || !children.length) {
        this.message = 'There are no dynamic content entrances at all!';
        return;
      }
      this.collectDynamicContents(children).then(() => {
        this.readyToExecute = true;
      })
    });
  }

  async execute() {
    if (this.running) {
      this.dialogService.confirm('already running, please wait!').then(() => {
        return;
      });
      return;
    }
    this.running = true;
    this.started = Date.now();
    for (let i = 0; i < this.dynamicContents.length; i++) {
      await this.renderQuill(this.dynamicContents[i]).then(() => {
        this.toDos--;
        this.elapsed = Date.now() - this.started;
        return true;
      });
    }
    this.message = 'Great, all are executed now. ';
    this.dynamicContents = [];
    this.running = false;
    this.readyToExecute = false;
  }

  renderQuill(content): any {
    return new Promise(async (resolve) => {
      console.log('rendering quill for :', content.title, content._id);
      this.dynamicContent = content;
      setTimeout(() => {
        this.dynamicContent.content.textContent = this.cleanUpQuillContent(this.dynamicContent.content.textContent);
        return this.dynamicContentService.update(this.dynamicContent._id, this.dynamicContent).then(result => {
          this.dynamicContent = null;
          resolve(true);
        });
      }, 200);
    });
  }

  onEditorChange(event) {
    this.dynamicContent.content.textContent = event;
  }

  public getDynamicContentEntranceIds(ids): any {
    let children = [];
    if (!ids || !ids.length) {
      return Promise.resolve(null);
    }
    return this.dynamicContentEntranceService.find(0, 100, { _id: { $in: ids } }).then(entrances => {
      if (!entrances || !entrances.data || !entrances.data.length) {
        console.log('dynamic content entrances with id in: ', ids, ' do not exist');
        return null;
      }
      entrances.data.map(entrance => {
        children = children.concat(entrance.children);
      });
      return children;
    });
  }

  public collectDynamicContents(children, level = 1): any {
    if (!children || !children.length) {
      return Promise.resolve();
    }
    const promises = children.map((id, index) => {
      return this.dynamicContentService.get(id).then(async dynamicContent => {
        let additionalIds = [];
        if (!dynamicContent) {
          this.message += 'child:' + index + ' does not exist /r/n';
          return;
        }
        if (dynamicContent.children && dynamicContent.children.length) {
          additionalIds = additionalIds.concat(dynamicContent.children);
        }
        if (dynamicContent.translationEntries && dynamicContent.translationEntries.length) {
          additionalIds = additionalIds.concat(dynamicContent.translationEntries);
        }
        if (dynamicContent.content && dynamicContent.content.textContent && dynamicContent.content.textContent.length) {
          this.toDos++;
          this.dynamicContents.push(dynamicContent);
        }
        return this.collectDynamicContents(additionalIds, level + 1);
      });
    });
    return Promise.all(promises).then(() => {
      return true;
    });
  }

  cleanUpQuillContent(content) {
    if (!content) {
      return content;
    }
    while (content.match(/<p><br><\/p>$/gm)) {
      content = content.replace(/<p><br><\/p>$/gm, '');
    }
    return content;
  }

  resetData() {
    this.readyToExecute = false;
    this.selected = null;
    this.toDos = 0;
    this.dynamicContents = [];
    this.message = null;
    this.started = null;
    this.elapsed = 0
  }
}
